import * as actions from './actions';
import reducer from './reducers';

export default { actions, reducer };
